/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { parse } from '../../../util/urlHelpers';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import RangeFilterPlain from './shared/RangeFilterPlain/RangeFilterPlain';
import { constructQueryParamName } from '../../../util/search';

import css from './SearchPageStyles.module.css';
import classNames from 'classnames';

const SEARCH_PARAM = constructQueryParamName('passengerCapacity', 'public');

const CapacityFilter = props => {
  const { className, ...rest } = props;

  const intl = useIntl();
  const history = useHistory();
  const routes = useRouteConfiguration();
  const { location } = history;

  const currentQueryParams = parse(location?.search);

  return (
    <RangeFilterPlain
      className={classNames(css.beamFilter, className)}
      id="passengerCapacity"
      label={intl.formatMessage({ id: 'EditListingDetailsForm.passengerCapacity' })}
      queryParamNames={SEARCH_PARAM}
      initialValues={{ [SEARCH_PARAM]: currentQueryParams[SEARCH_PARAM] }}
      min={0}
      step={1}
      max={100}
      formatNumber={false}
      liveEdit
      showRangeInLabel
      {...rest}
    />
  );
};

export default CapacityFilter;
